import { render, staticRenderFns } from "./grupi1.vue?vue&type=template&id=2526d84a&scoped=true&"
import script from "./grupi1.vue?vue&type=script&lang=js&"
export * from "./grupi1.vue?vue&type=script&lang=js&"
import style0 from "./grupi1.vue?vue&type=style&index=0&id=2526d84a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2526d84a",
  null
  
)

export default component.exports